enum MenuVariant {
  Hover = 'hover',
  Underline = 'underline',
}

export default MenuVariant;
